import type { FC } from "react";
import { Col, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import BlackEnvelope from "components/Box/BlackEnvelope";
import EnvelopeStackIcon from "components/EnvelopeStackIcon/EnvelopeStackIcon";

import type { IEnvelopeCounts } from "features/DashboardEnvelopesSummary/DashboardEnvelopesSummary";

import { useAppDispatch } from "store/hooks";
import { setFrom } from "store/slices/envelopeNavigation";

interface Props {
  data: IEnvelopeCounts;
}

const EnvelopesSummary: FC<Props> = ({ data }) => {
  const { t } = useTranslation(["common"]);
  const dispatch = useAppDispatch();

  const sum = data.green + data.yellow + data.red + data.black;

  const handleClick = () => {
    dispatch(setFrom("/"));
  };

  return (
    <Row className={"g-2"}>
      <Col xs={2}>
        <Link to="/ulohy/obalka/cervena" onClick={handleClick} className="envelope">
          <div className="envelope__label envelope__label--red">
            {t("assignmentsWithCount", { ns: "common", count: data.red })}
          </div>
          <EnvelopeStackIcon type={"red"} percentage={data.red === 0 ? 0 : data.red / sum} />
          <p className="envelope__description">{t("dashboardEnvelopes.red", { ns: "envelope" })}</p>
        </Link>
      </Col>
      <Col xs={2}>
        <Link to="/ulohy/obalka/oranzova" onClick={handleClick} className="envelope">
          <div className="envelope__label envelope__label--orange">
            {t("assignmentsWithCount", { ns: "common", count: data.yellow })}
          </div>
          <EnvelopeStackIcon type={"orange"} percentage={data.yellow === 0 ? 0 : data.yellow / sum} />
          <p className="envelope__description">{t("dashboardEnvelopes.orange", { ns: "envelope" })}</p>
        </Link>
      </Col>
      <Col xs={2}>
        <Link to="/ulohy/obalka/zelena" onClick={handleClick} className="envelope">
          <div className="envelope__label envelope__label--green">
            {t("assignmentsWithCount", { ns: "common", count: data.green })}
          </div>
          <EnvelopeStackIcon type={"green"} percentage={data.green === 0 ? 0 : data.green / sum} />
          <p className="envelope__description">{t("dashboardEnvelopes.green", { ns: "envelope" })}</p>
        </Link>
      </Col>
      <Col xs={6} className="envelope envelope--no-hover">
        <Row className="envelope__columns">
          <Col xs={4}>
            <div className="d-flex flex-column align-items-center gap-1 envelope--black">
              <div className="envelope__label envelope__label--black">
                {t("assignmentsWithCount", { ns: "common", count: data.black })}
              </div>
              <EnvelopeStackIcon type={"black"} percentage={data.black === 0 ? 0 : data.black / sum} />
              <p className="envelope__description">
                <Trans
                  i18nKey="dashboardEnvelopes.black"
                  ns="envelope"
                  components={{
                    span: <span style={{ color: "red" }} />,
                  }}
                />
              </p>
            </div>
          </Col>

          <Col xs={8}>
            <BlackEnvelope />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EnvelopesSummary;
